import { render, staticRenderFns } from "./left_panel_header.vue?vue&type=template&id=6c4d5ef4&scoped=true"
import script from "./left_panel_header.vue?vue&type=script&lang=js"
export * from "./left_panel_header.vue?vue&type=script&lang=js"
import style0 from "./left_panel_header.vue?vue&type=style&index=0&id=6c4d5ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d5ef4",
  null
  
)

export default component.exports